const prefix = "app/ReportsV2/WidgetResultByDivision"

export const GET_DIVISIONS_WATCHER = `${prefix}/GET_DIVISIONS_WATCHER`
export const GET_DIVISIONS_SUCCESS = `${prefix}/GET_DIVISIONS_SUCCESS`
export const GET_DIVISIONS_FAILED = `${prefix}/GET_DIVISIONS_FAILED`
export const GET_DIVISIONS_BY_DIMENSION_WATCHER = `${prefix}/GET_DIVISIONS_BY_DIMENSION_WATCHER`
export const GET_DIVISIONS_BY_DIMENSION_SUCCESS = `${prefix}/GET_DIVISIONS_BY_DIMENSION_SUCCESS`
export const GET_DIVISIONS_BY_DIMENSION_FAILED = `${prefix}/GET_DIVISIONS_BY_DIMENSION_FAILED`
